<div class="fade-in" style="background-color: #f8fafc; height: 100%; min-height: 100vh; overflow-x: hidden;">
  <div class="content-section">
    <div class="section-header">
      <div style="display: flex; align-items: center; gap: 16px;">
        <button class="secondary-btn" (click)="close()">← Back to Frames</button>
        <h2 style="margin: 0; color: #1e293b;">Manage Assets: <span class="text-highlight">{{ frameId }}</span></h2>
      </div>
    </div>

    <div class="upload-notice" role="status" *ngIf="uploadNotice">
      <span>{{ uploadNotice }}</span>
      <button type="button" class="notice-dismiss" (click)="uploadNotice = null" aria-label="Dismiss">×</button>
    </div>

    <div class="loading-container" *ngIf="isLoading">
      <div class="spinner-small" style="border-color: #2563eb; border-bottom-color: transparent;"></div>
      <p style="color: #64748b; margin-top: 8px;">Loading assets...</p>
    </div>

    <div class="assets-grid" *ngIf="!isLoading">
      <!-- Category Sections -->
      <div class="category-card" *ngFor="let cat of visibleCategories"
        [class.selected-card]="selectedCategoryForPreview === cat.id">
        <div class="category-header" (click)="selectCategory(cat.id)" style="cursor: pointer;"
          [class.selected-header]="selectedCategoryForPreview === cat.id">
          <h3 style="margin: 0;">{{ cat.icon }} {{ cat.name }} <span class="suffix-badge">{{ cat.id }}</span></h3>
          <div>
            <ng-container *ngIf="cat.id === '_FP' && !version">
              <button class="primary-btn sm-btn" (click)="openPreviewModal(); $event.stopPropagation()">+ Upload
                Previews</button>
            </ng-container>
            <ng-container *ngIf="cat.id !== '_FP' && !version">
              <label [for]="'upload' + cat.id" class="primary-btn sm-btn" style="cursor: pointer;"
                (click)="$event.stopPropagation()">
                <span *ngIf="!isUploading[cat.id]">+ Upload PNGs</span>
                <span *ngIf="isUploading[cat.id]"><span class="spinner-small"
                    style="display: inline-block; vertical-align: middle; width: 12px; height: 12px; border-width: 2px; border-color: white; border-bottom-color: transparent;"></span>
                  Uploading...</span>
              </label>
              <input [id]="'upload' + cat.id" type="file" multiple accept=".png" (change)="uploadImages($event, cat.id)"
                [disabled]="isUploading[cat.id]" style="display: none;">
            </ng-container>
          </div>
        </div>

        <div class="assets-list" *ngIf="(categorizedAssets[cat.id]?.length ?? 0) > 0">
          <ng-container *ngFor="let asset of categorizedAssets[cat.id]; let i = index">
            <div class="asset-item" *ngIf="i < 2">
              <div class="asset-thumbnail" (click)="openPreview(asset)" title="Click to view full size">
                <img [src]="asset.url" alt="Asset Preview">
              </div>
              <div class="asset-info">
                <span class="asset-name" [title]="asset.name">{{ asset.name }}</span>
                <button class="icon-action-btn danger sm" *ngIf="!version" (click)="deleteAsset(asset)"
                  title="Delete Asset">🗑️</button>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="empty-state" *ngIf="(categorizedAssets[cat.id]?.length ?? 0) === 0">
          <p>{{ emptyCategoryText }}</p>
        </div>
      </div>
    </div>

    <!-- All Previews Section -->
    <div class="category-card" style="margin-top: 2rem;" *ngIf="selectedCategoryForPreview">
      <div class="category-header" style="display: flex; justify-content: space-between; align-items: center;">
        <h3 style="margin: 0; color: #1e293b;">All Previews for <span class="text-highlight">{{
            selectedCategoryForPreview }}</span></h3>
        <button class="primary-btn sm-btn" *ngIf="!version && selectedCategoryForPreview === '_FP'" (click)="saveOrder()" [disabled]="isSavingOrder">
           <span *ngIf="!isSavingOrder">💾 Save Order</span>
           <span *ngIf="isSavingOrder">Saving...</span>
        </button>
      </div>
      <div class="assets-list" style="grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));"
        *ngIf="(categorizedAssets[selectedCategoryForPreview]?.length ?? 0) > 0">
        <div class="asset-item" *ngFor="let asset of categorizedAssets[selectedCategoryForPreview]; let i = index"
             [draggable]="!version && selectedCategoryForPreview === '_FP'"
             (dragstart)="onDragStart(i, $event)"
             (dragover)="onDragOver($event)"
             (drop)="onDrop(i, $event)"
             [style.cursor]="!version && selectedCategoryForPreview === '_FP' ? 'grab' : 'default'">
          <div class="asset-thumbnail" style="height: 200px;" (click)="openPreview(asset)"
            title="Click to view full size">
            <img [src]="asset.url" alt="Asset Preview">
          </div>
          <div class="asset-info">
            <span class="asset-name" [title]="asset.name">{{ asset.name }}</span>
            <button class="icon-action-btn danger sm" *ngIf="!version" (click)="deleteAsset(asset)"
              title="Delete Asset">🗑️</button>
          </div>
        </div>
      </div>
      <div class="empty-state" *ngIf="(categorizedAssets[selectedCategoryForPreview]?.length ?? 0) === 0">
        <p>No images available.</p>
      </div>
    </div>
  </div>
</div>

<!-- Full Size Image Preview Modal (shared popup, KAN-149 AC-6) with the Frame Settings panel -->
<app-frame-image-preview [url]="previewAsset?.url || null" [hasPanel]="true" (closed)="closePreview()">
  <ng-container *ngIf="previewAsset">
    <div class="settings-head">
      <h3 class="settings-title">Frame Settings</h3>
      <button *ngIf="!isEditingFrameSettings && !version" class="icon-action-btn primary sm" (click)="startEditFrameSettings()" title="Edit Settings">✏️ Edit</button>
    </div>

    <div class="settings-row">
      <span class="settings-label">File Name:</span>
      <div class="settings-value break-all">{{ previewAsset.name }}</div>
    </div>

    <!-- Owner (KAN-149 AC-3): _FP frames only -->
    <div class="settings-row" *ngIf="isFpAsset(previewAsset) && !isEditingFrameSettings">
      <span class="settings-label">Owner:</span>
      <div class="settings-value" *ngIf="previewOwnerLoaded">
        <span *ngIf="previewOwnerId; else ownerUnassigned">{{ artistName(previewOwnerId) }}</span>
        <ng-template #ownerUnassigned><span class="status-pill-neutral">{{ ownershipText.unassigned }}</span></ng-template>
        <span class="status-pill-warn" *ngIf="previewOwnerInactive">{{ ownershipText.inactive }}</span>
      </div>
      <div class="settings-value muted" *ngIf="!previewOwnerLoaded && !ownerError">Loading…</div>
    </div>
    <div class="field-error" role="alert" *ngIf="ownerError">{{ ownerError }}</div>

    <!-- View Mode -->
    <ng-container *ngIf="!isEditingFrameSettings">
      <div class="settings-row" *ngIf="previewAsset.cutStyle">
        <span class="settings-label">Frame Type:</span>
        <div class="settings-value">{{ previewAsset.cutStyle }}</div>
      </div>
      <div class="settings-row" *ngIf="previewAsset.dateColor">
        <span class="settings-label">Date Color:</span>
        <div class="settings-value color-row">
          <div class="color-swatch" [style.background-color]="previewAsset.dateColor"></div>
          {{ previewAsset.dateColor }}
        </div>
      </div>
    </ng-container>

    <!-- Edit Mode -->
    <ng-container *ngIf="isEditingFrameSettings">
      <div class="settings-row">
        <label class="settings-label block" for="edit-cut-style">Frame Type:</label>
        <select id="edit-cut-style" [(ngModel)]="editCutStyle" class="form-select settings-select">
          <option *ngFor="let style of cutStyles" [value]="style">{{ style }}</option>
        </select>
      </div>
      <div class="settings-row">
        <label class="settings-label block" for="edit-date-color">Date Color:</label>
        <div class="color-row">
          <input id="edit-date-color" type="color" [(ngModel)]="editDateColor" class="color-input-sm">
          <span class="mono-value">{{ editDateColor | uppercase }}</span>
        </div>
      </div>
      <div class="settings-row" *ngIf="isFpAsset(previewAsset) && previewOwnerLoaded">
        <label class="settings-label block" for="edit-artist">Artist:</label>
        <select id="edit-artist" [(ngModel)]="editArtistId" class="form-select settings-select" [disabled]="artistsLoadFailed">
          <option [ngValue]="null">{{ ownershipText.unassigned }}</option>
          <option *ngIf="previewOwnerNotAssignable" [ngValue]="previewOwnerId">{{ artistName(previewOwnerId) }} ({{ ownershipText.inactive | lowercase }})</option>
          <option *ngFor="let a of assignableArtists" [ngValue]="a.id">{{ a.name }}</option>
        </select>
        <div class="field-hint">{{ ownershipText.allCopies }}</div>
      </div>
      <div class="settings-actions">
        <button class="primary-btn sm-btn" (click)="saveFrameSettings()" [disabled]="isSavingFrameSettings">
          <span *ngIf="!isSavingFrameSettings">Save</span>
          <span *ngIf="isSavingFrameSettings">Saving...</span>
        </button>
        <button class="secondary-btn sm-btn" (click)="cancelEditFrameSettings()" [disabled]="isSavingFrameSettings">Cancel</button>
      </div>
    </ng-container>
    <div class="settings-row" *ngIf="previewAsset.timeCreated">
      <span class="settings-label">Uploaded Date:</span>
      <div class="settings-value">{{ previewAsset.timeCreated | date:'medium' }}</div>
    </div>
  </ng-container>
</app-frame-image-preview>

<!-- Upload Modal -->
<div class="modal-overlay" *ngIf="isPreviewModalOpen">
  <div class="modal-box">
    <div class="modal-header">
      <h3>Upload Previews</h3>
      <button class="close-btn" (click)="closePreviewModal()">×</button>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label class="upload-label" for="upload-fp">Frame Preview (FP)</label>
        <div class="file-pick-row">
          <label for="upload-fp" class="secondary-btn file-pick-btn">Choose File</label>
          <span class="file-pick-name">{{ selectedFpFile ? selectedFpFile.name : 'No file chosen' }}</span>
        </div>
        <input id="upload-fp" type="file" accept=".png" (change)="onFpFileSelected($event)" class="visually-hidden-input">
      </div>

      <div class="form-group upload-field-gap">
        <label class="upload-label" for="upload-cut-style">Cut Style</label>
        <select id="upload-cut-style" [(ngModel)]="selectedFrameType" class="form-select settings-select">
          <option *ngFor="let style of cutStyles" [value]="style">{{ style }}</option>
        </select>
      </div>

      <div class="form-group upload-field-gap">
        <label class="upload-label" for="upload-date-color">Date Text Color</label>
        <div class="color-row">
          <input id="upload-date-color" type="color" [(ngModel)]="selectedDateColor" class="color-input-lg">
          <span class="mono-value">{{ selectedDateColor | uppercase }}</span>
        </div>
      </div>

      <!-- KAN-149 AC-2: optional artist; the frame can be assigned later in Artist Management -->
      <div class="form-group upload-field-gap">
        <label class="upload-label" for="upload-artist">Artist (optional)</label>
        <select id="upload-artist" [(ngModel)]="uploadArtistId" class="form-select settings-select" [disabled]="artistsLoadFailed || isUploadingPair">
          <option [ngValue]="null">{{ ownershipText.unassigned }}</option>
          <option *ngFor="let a of assignableArtists" [ngValue]="a.id">{{ a.name }}</option>
        </select>
        <div class="field-hint" *ngIf="!artistsLoadFailed">Leave Unassigned for company-owned frames. If this frame ID already has an owner, it keeps that owner unless you pick another artist.</div>
        <div class="field-error" role="alert" *ngIf="artistsLoadFailed">{{ ownershipText.artistsLoadFailed }}</div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="secondary-btn" (click)="closePreviewModal()" [disabled]="isUploadingPair">Cancel</button>
      <button class="primary-btn" (click)="uploadPreviews()"
        [disabled]="isUploadingPair || !selectedFpFile">
        <span *ngIf="!isUploadingPair">Upload</span>
        <span *ngIf="isUploadingPair">Uploading...</span>
      </button>
    </div>
  </div>
</div>
